import {UPLOAD_ASSET_REQUEST_MANAGER_EVENT} from './actions';

export enum UploadAssetRequestManagerRoute {
	BASE = 'assets/requests',
}

export const routes = <const>{
	[UploadAssetRequestManagerRoute.BASE]:
		UPLOAD_ASSET_REQUEST_MANAGER_EVENT.VIEW,
};

export default routes;
